import { find } from 'lodash'

import { setPage } from 'store/actions/tables'
import { updateLocalSetting } from 'store/actions/settings'
import { store } from 'store/reducers'

const onClickPunchCardActionRequiredAlert = saveOptions => {
  const filterKey = `filter-punchCards`
  const {
    settings: { [filterKey]: savedOptions = {} }
  } = store.getState()

  // If the actionRequired option is already chosen, do nothing
  if (savedOptions?.others && find(savedOptions?.others, option => option === 'actionRequired')) return
  // Add actionRequired  filter to savedOptions
  const options = { ...savedOptions, others: [...(savedOptions?.others || []), 'actionRequired'] }
  saveOptions(options, { ignoreLargeCompany: true })
  store.dispatch(updateLocalSetting(`last-page-viewed-punchCards`, 1))
  store.dispatch(setPage('punchCards', 1))
}

export default onClickPunchCardActionRequiredAlert
